export default "__VITE_ASSET__NvhMwj8T__"